/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleProvisioningControllerListRecordsQueryResponse, TrimbleProvisioningControllerListRecordsQueryParams, TrimbleProvisioningControllerListRecords401, TrimbleProvisioningControllerListRecords403 } from "../../models/trimbleProvisioningController/TrimbleProvisioningControllerListRecords";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { trimbleProvisioningControllerListRecords } from "../../clients/trimble-provisioningService/trimbleProvisioningControllerListRecords";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const trimbleProvisioningControllerListRecordsQueryKey = (params: TrimbleProvisioningControllerListRecordsQueryParams = {}) => [{
  url: '/api/v1/trimble-provisioning-records'
}, ...(params ? [params] : [])] as const;
export type TrimbleProvisioningControllerListRecordsQueryKey = ReturnType<typeof trimbleProvisioningControllerListRecordsQueryKey>;
export function trimbleProvisioningControllerListRecordsQueryOptions(params?: TrimbleProvisioningControllerListRecordsQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = trimbleProvisioningControllerListRecordsQueryKey(params);
  return queryOptions<TrimbleProvisioningControllerListRecordsQueryResponse, ResponseErrorConfig<TrimbleProvisioningControllerListRecords401 | TrimbleProvisioningControllerListRecords403>, TrimbleProvisioningControllerListRecordsQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return trimbleProvisioningControllerListRecords(params, config);
    }
  });
}

/**
 * @summary List organizations provisioned from Trimble EMS entitlement events
 * {@link /api/v1/trimble-provisioning-records}
 */
export function useTrimbleProvisioningControllerListRecords<TData = TrimbleProvisioningControllerListRecordsQueryResponse, TQueryData = TrimbleProvisioningControllerListRecordsQueryResponse, TQueryKey extends QueryKey = TrimbleProvisioningControllerListRecordsQueryKey>(params?: TrimbleProvisioningControllerListRecordsQueryParams, options: {
  query?: Partial<QueryObserverOptions<TrimbleProvisioningControllerListRecordsQueryResponse, ResponseErrorConfig<TrimbleProvisioningControllerListRecords401 | TrimbleProvisioningControllerListRecords403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? trimbleProvisioningControllerListRecordsQueryKey(params);
  const query = useQuery({
    ...trimbleProvisioningControllerListRecordsQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TrimbleProvisioningControllerListRecords401 | TrimbleProvisioningControllerListRecords403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}